import React from 'react';
import image from '../../res/image';
import Const from "../../const";

// @todo: 일단 만들고  antd를 적용할 예정입니다. by riverstyx
const Pagination = ({
  current,
  total,
  pageSize,
  pagedListSize,
  onChange,
  defaultCurrent = 1,
  defaultPageSize = 10,
  defaultPagedListSize = 5,
}) => {
  current = current === undefined ? defaultCurrent : current;
  pageSize = pageSize === undefined ? defaultPageSize : pageSize;
  pagedListSize =
    pagedListSize === undefined ? defaultPagedListSize : pagedListSize;

  const pageCount = Math.ceil(total / pageSize);
  const nowPagedList = Math.ceil(current / pagedListSize);
  const totalPagedList = Math.ceil(pageCount / pagedListSize);

  const pagedListNumber = [];
  const startPagedList =
    pageCount === 0 ? 1 : (nowPagedList - 1) * pagedListSize + 1;
  const endPagedList =
    pageCount === 0
      ? 1
      : nowPagedList === totalPagedList
      ? pageCount
      : nowPagedList * pagedListSize;

  for (let i = startPagedList; i <= endPagedList; ++i) {
    pagedListNumber.push(i);
  }

  const skinType = Const.skinType.toUpperCase();
  return (
    <div className="delivery-element-btn">
      <div className="delivery-element-btn-left">
        <img
          style={{ display: 'inline' }}
          src={image.LeftBtn1Icon}
          onClick={() => {
            if (current !== 1) {
              onChange(
                nowPagedList > 1 ? (nowPagedList - 1) * pagedListSize : 1
              );
            }
          }}
          alt=""
        />
      </div>

      <div className="delivery-element-btn-left2">
        <img
          style={{ display: 'inline' }}
          src={image.LeftBtn2Icon}
          onClick={() => {
            if (current > 1) {
              onChange(current - 1);
            }
          }}
          alt=""
        />
      </div>

      <div className="delivery-element-btn-block">
        {pagedListNumber &&
          pagedListNumber.map((page) =>
            page === current ? (
              <div className={skinType === "GOGOIT" ? "gogoit-delivery-element-btn-block-num" : "delivery-element-btn-block-num"} key={page}>
                {page}
              </div>
            ) : (
              <div
                className="delivery-element-btn-block-num2"
                key={page}
                onClick={() => onChange(page)}>
                {page}
              </div>
            )
          )}
      </div>

      <div className="delivery-element-btn-right">
        <img
          style={{ display: 'inline' }}
          src={image.RightBtn2Icon}
          onClick={() => {
            if (current < pageCount) {
              onChange(current + 1);
            }
          }}
          alt=""
        />
      </div>

      <div className="delivery-element-btn-right2">
        <img
          style={{ display: 'inline' }}
          src={image.RightBtn1Icon}
          onClick={() => {
            if (current < pageCount) {
              onChange(
                nowPagedList < totalPagedList
                  ? nowPagedList * pagedListSize + 1
                  : pageCount
              );
            }
          }}
          alt=""
        />
      </div>
    </div>
  );
};

export default Pagination;
